import { render, staticRenderFns } from "./CreateReceipt.vue?vue&type=template&id=ad675ed0&"
import script from "./CreateReceipt.vue?vue&type=script&lang=js&"
export * from "./CreateReceipt.vue?vue&type=script&lang=js&"
import style0 from "./CreateReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports